import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import decode from 'jwt-decode';

import Login from '../login/index';
import CupomChecker from '../cupomchecker';
import CupomData from '../cupomData';
import CupomRescued from "../cupomrescued";

const isTokenExpired = (token) => {
  try {
    const decoded = decode(token);
    if (decoded.exp < Date.now() / 1000) {
      return true;
    }
    else
      return false;
  }
  catch (err) {
    return false;
  }
}

const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  return !!token && !isTokenExpired(token);
}

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
      )
    }
  />
);

const Routes = () => (
  <BrowserRouter>
    <Switch>
      {/* <Route exact path="/login" component={Login} /> */}
      <Route exact path="/" component={CupomChecker} />
      <Route path="/cupomData" component={CupomData} />
      <Route path="/cupomRescued" component={CupomRescued} />
    </Switch>
  </BrowserRouter>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/components/client/Routes.js